import { useAuth0 } from '@auth0/auth0-react';
import styles from './list.module.css';
import { useHistory } from "react-router-dom";
import { Edit, MoreVertical, Trash2, User, X, Send, CheckCircle, Clock, AlertTriangle, AlertCircle } from 'react-feather';
import { useState, Fragment } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Dialog } from '@mui/material';

const MobileViewList = ({ rowsData, setSelectedId, setDeleteVehicleModalOpen, setEditModalOpen, setEditData }) => {
    const redirect = useHistory();
    const { user, isAuthenticated } = useAuth0();
    const [expandedMobileCardId, setExpandedMobileCardId] = useState(null);
    const [carImage, setCarImage] = useState("");
    const [openPop, setOpenPop] = useState(false);

    const goToDetails = (item) => {
        if (isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1) {
            setEditModalOpen(true);
            setEditData(item);
        } else {
            return false;
        }
    }

    return (<>
        <div className={`${styles.ListMobileView}`}>
            {rowsData.map((card) => {
                const isGuest = card.is_guest === 1;
                const isExpanded = expandedMobileCardId === card.id;

                // Pass info for guest
                let passLabel = "";
                let passColor = "";
                let alertClass = "";
                let alertIcon = null;
                let alertText = "";
                let passPrice = card.passType === "monthly" ? 30.00 : 5.00;
                let passName = card.passType === "monthly" ? "Monthly pass" : "Day pass";
                let passStatusIcon = null;
                let passStatusText = "";
                let passValidFrom = null;
                let passWasValid = null;
                let passExpires = null;
                let passRemaining = null;

                if (isGuest) {
                    if (card.passStatus === "active") {
                        passLabel = "Active";
                        passColor = "#5AC55E";
                        passStatusText = "Paid & Active";
                        passStatusIcon = <CheckCircle size={14} style={{ color: '#5AC55E' }} />;
                        passValidFrom = "Jun 16, 2026";
                        passExpires = "Jun 17, 2026";
                        passRemaining = "14h 32m";
                        alertClass = styles.AlertBannerWarning;
                        alertIcon = <AlertTriangle size={16} />;
                        alertText = "Pass expires in less than 24 hours. Send renewal link to guest.";
                    } else if (card.passStatus === "expired") {
                        passLabel = "Expired";
                        passColor = "#E23725";
                        passStatusText = "Expired";
                        passStatusIcon = <X size={14} style={{ color: '#E23725' }} />;
                        passWasValid = "May 16 - Jun 15, 2026";
                        alertClass = styles.AlertBannerError;
                        alertIcon = <AlertCircle size={16} />;
                        alertText = `Access restricted. ${card.passType === "monthly" ? "Monthly" : "Day"} pass expired Jun 15, 2026.`;
                    } else {
                        passLabel = "Awaiting";
                        passColor = "#E99A37";
                        passStatusText = "Awaiting payment";
                        passStatusIcon = <Clock size={14} style={{ color: '#E99A37' }} />;
                        alertClass = styles.AlertBannerWarning;
                        alertIcon = <AlertTriangle size={16} />;
                        alertText = "Payment link sent Jun 16. Guest has not paid yet.";
                    }
                }

                return (
                    <div key={card.id} className={`${styles.MobileVehicleCardWrapper}`} style={isExpanded ? { borderColor: '#C7D2FE' } : {}}>
                        {/* <div 
                            className={`${styles.MobileVehicleMainCard}`} 
                            onClick={(e) => { 
                                e.preventDefault(); 
                                e.stopPropagation(); 
                                if (isGuest) {
                                    setExpandedMobileCardId(isExpanded ? null : card.id); 
                                } else {
                                    goToDetails(card);
                                }
                            }}
                            style={{ cursor: 'pointer' }}
                        > */}
                        <div className={`${styles.MobileVehicleMainCard}`}>
                            <div className={`${styles.MobileCarIconBox}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); setCarImage(card.image_path); setOpenPop(true); }}>
                                {card.image_thumbail_path ? <img src={card.image_path} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : <img src="/static/img/car.svg" alt="" style={{ width: '40px', height: '40px', opacity: 0.7 }} />}
                                {card.isNew && (<span className={`${styles.MobileNewBadge}`}>New</span>)}
                            </div>

                            <div className={`${styles.MobileCardTextSec}`}>
                                <p className={`${styles.MobileCardTitle}`}>
                                    {isGuest ? (
                                        <span style={{ color: '#ff8271', fontWeight: 600 }}>{card.name}</span>
                                    ) : (
                                        <span onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/people/tenants/details/" + card.tenant_id); }}>{card.name}</span>
                                    )}
                                    {isGuest && <span className={styles.MobileGuestInlineBadge}>Guest</span>}
                                </p>
                                
                                <p className={`${styles.MobileCardSub}`}>
                                    {card.license}
                                    {isGuest && <span> · {card.phone}</span>}
                                </p>
                                <p className={`${styles.MobileCardSub}`}>{card.make} · {card.model} · {card.color}</p>
                                <p className={`${styles.MobileCardProp}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); redirect.push("/properties/details/" + card.property_id); }}>{card.property} · {card.unit}</p>
                            </div>

                            <div className={`${styles.MobileCardRightSec}`} style={{ alignSelf: 'center' }}>
                                {isAuthenticated && user["https://propertydek.com/permissions"].indexOf("vehicle:update") > -1 && (
                                    <Dropdown className={`${styles.ActionLeaseBUSec}`} onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}>
                                        <Dropdown.Toggle className={`${styles.ActionsLeaseBU} ActionsBU`} id="dropdown-basic">
                                            <MoreVertical />
                                        </Dropdown.Toggle>

                                        <Dropdown.Menu className={`${styles.ActionsBUList} ActionsBUList`}>
                                            <Dropdown.Item className={`${styles.EditActionsBUListItem}`} onClick={(e) => { setEditModalOpen(true); setEditData(card); }}>
                                                <Edit /> Edit
                                            </Dropdown.Item>
                                            <Dropdown.Item className={`${styles.EditActionsBUListItem} ${styles.Delete}`} onClick={(e) => { setDeleteVehicleModalOpen(true); setSelectedId(card?.id); }}>
                                                <Trash2 /> Delete
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                )}

                                {/* {isGuest && (
                                    <div 
                                        className={`${styles.MobileGuestCountBadge}`} 
                                        style={{ backgroundColor: card.passStatus === 'expired' ? '#FEE2E2' : card.passStatus === 'awaiting' ? '#FEF3C7' : '#D1FAE5', color: passColor }}
                                    >
                                        <span>{passLabel}</span>
                                    </div>
                                )} */}
                            </div>
                        </div>

                        {isExpanded && isGuest && (
                            <div className={`${styles.MobileGuestPanel}`}>
                                <div className={styles.MobileGuestFeePanelHeader}>
                                    <span>PARKING PASS</span>
                                </div>
                                <div className={`${styles.MobileGuestFeeBody}`}>
                                    <div className={`${styles.MobilePassStatsGrid}`}>
                                        <div className={`${styles.MobilePassStatItem}`}>
                                            <span className={`${styles.MobilePassStatLabel}`}>Pass type</span>
                                            <span className={`${styles.MobilePassStatVal}`}>{passName} - ${passPrice.toFixed(2)}</span>
                                        </div>
                                        <div className={`${styles.MobilePassStatItem}`}>
                                            <span className={`${styles.MobilePassStatLabel}`}>STATUS</span>
                                            <span className={`${styles.MobilePassStatVal}`} style={{ color: passColor }}>{passStatusIcon} {passStatusText}</span>
                                        </div>
                                        {(passValidFrom || passWasValid || passExpires || passRemaining) && (<>
                                            {passValidFrom && (
                                                <div className={`${styles.MobilePassStatItem}`}>
                                                    <span className={`${styles.MobilePassStatLabel}`}>VALID FROM</span>
                                                    <span className={`${styles.MobilePassStatVal}`}>{passValidFrom}</span>
                                                </div>
                                            )}
                                            {passWasValid && (
                                                <div className={`${styles.MobilePassStatItem}`}>
                                                    <span className={`${styles.MobilePassStatLabel}`}>WAS VALID</span>
                                                    <span className={`${styles.MobilePassStatVal}`}>{passWasValid}</span>
                                                </div>
                                            )}
                                            {passExpires && (
                                                <div className={`${styles.MobilePassStatItem}`}>
                                                    <span className={`${styles.MobilePassStatLabel}`}>EXPIRES</span>
                                                    <span className={`${styles.MobilePassStatVal}`}>{passExpires}</span>
                                                </div>
                                            )}
                                            {passRemaining && (
                                                <div className={`${styles.MobilePassStatItem}`}>
                                                    <span className={`${styles.MobilePassStatLabel}`}>REMAINING</span>
                                                    <span className={`${styles.MobilePassStatVal}`}>{passRemaining}</span>
                                                </div>
                                            )}
                                        </>)}
                                    </div>

                                    <div style={{ display: 'flex', gap: '8px', width: '100%', marginTop: '4px' }}>
                                        <button className={styles.SendRenewalButton} style={{ flex: 1, justifyContent: 'center', padding: '6px 12px' }}>
                                            <Send size={12} />
                                            Send renewal
                                        </button>
                                        <button className={styles.RevokeButton} style={{ flex: 1, justifyContent: 'center', padding: '6px 12px' }}>
                                            {card.passStatus === 'awaiting' ? 'Cancel' : 'Revoke'}
                                        </button>
                                    </div>

                                    <div className={alertClass} style={{ marginTop: '8px', padding: '8px 12px' }}>
                                        {alertIcon}
                                        <span style={{ fontSize: '11px' }}>{alertText}</span>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                );
            })}
        </div>

        <Dialog
            open={openPop}
            onClose={(e) => {
                e.preventDefault();
                e.stopPropagation();
                setOpenPop(false);
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <div className={`${styles.PopupImgSec}`}>
                <img src={carImage} alt="" />
                <button onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpenPop(false);
                }}><X /></button>
            </div>
        </Dialog>
    </>)
}

export default MobileViewList;